import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Image,
  ImageBackground,
  StyleSheet,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { colors, fontFamily } from "../../../constants/theme";

/**
 * Inline banner below the map’s top button row when the user is near a restaurant.
 */
export default function NearbyRestaurantBanner({
  nearbyRestaurant,
  onCheckIn,
  onClose,
  cardStyle,
}) {
  if (!nearbyRestaurant) return null;

  return (
    <View style={[styles.card, cardStyle]}>
      <TouchableOpacity
        onPress={onClose}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
        style={styles.closeBtn}
        accessibilityRole="button"
        accessibilityLabel="Dismiss nearby restaurant"
      >
        <Ionicons name="close-circle" size={24} color="#9C8A80" />
      </TouchableOpacity>

      <View style={styles.mainRow}>
        <View style={styles.thumbWrap}>
          {nearbyRestaurant.imgUrl || nearbyRestaurant.thumbnail ? (
            <Image
              source={{ uri: nearbyRestaurant.thumbnail || nearbyRestaurant.imgUrl }}
              style={styles.thumbImage}
              resizeMode="cover"
            />
          ) : (
            <ImageBackground
              source={require("../../../assets/nonDisgoPartnerMembershipCard.jpg")}
              style={styles.thumbImage}
              imageStyle={styles.thumbImageRadius}
            />
          )}
        </View>

        <View style={styles.contentCol}>
          <View style={styles.textBlock}>
            <Text style={styles.kicker}>You're nearby!</Text>
            <Text style={styles.title} numberOfLines={2}>
              {nearbyRestaurant.name}
            </Text>
          </View>
          <TouchableOpacity
            onPress={() => {
              onCheckIn(nearbyRestaurant._id);
              onClose();
            }}
            style={styles.btnPrimary}
            accessibilityRole="button"
            accessibilityLabel="Share bite at this restaurant"
          >
            <Text style={styles.btnPrimaryText}>Share Bite</Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    marginTop: 8,
    borderRadius: 12,
    overflow: "hidden",
    paddingHorizontal: 12,
    paddingVertical: 12,
    backgroundColor: "#F9F5F3",
    borderWidth: 1.5,
    borderColor: "#E8DFD8",
  },
  closeBtn: {
    position: "absolute",
    top: 8,
    right: 8,
    zIndex: 1,
  },
  mainRow: {
    flexDirection: "row",
    alignItems: "stretch",
    minHeight: 80,
    paddingRight: 28,
  },
  thumbWrap: {
    alignSelf: "flex-start",
    borderRadius: 10,
    overflow: "hidden",
    marginRight: 12,
    width: 80,
    height: 80,
  },
  thumbImage: {
    width: "100%",
    height: "100%",
  },
  thumbImageRadius: {
    borderRadius: 10,
  },
  contentCol: {
    flex: 1,
    minWidth: 0,
    minHeight: 80,
    flexDirection: "column",
  },
  textBlock: {
    flexShrink: 1,
  },
  kicker: {
    fontSize: 14,
    fontFamily: fontFamily.abhaya,
    color: "#9C8A80",
    marginBottom: 2,
  },
  title: {
    fontSize: 19,
    fontFamily: fontFamily.abhayaBold,
    color: colors.black,
    lineHeight: 24,
    paddingRight: 4,
  },
  btnPrimary: {
    alignSelf: "stretch",
    marginTop: "auto",
    backgroundColor: colors.yellow900,
    borderRadius: 8,
    paddingVertical: 9,
    paddingHorizontal: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  btnPrimaryText: {
    color: colors.white,
    fontFamily: fontFamily.abhayaBold,
    fontSize: 15,
  },
});
